module.exports = __webpack_public_path__ + "img/placeholderImage.a2fd5e63.svg";